import { observe } from "mobx";

import contentViewTypes from "../../constants/contentViewTypes";
import modalViewTypes from "../../constants/modalViewTypes";

const withHomeClaimFlow = BaseClass =>
  class extends BaseClass {
    setObservers() {
      if (super.setObservers) {
        super.setObservers();
      }

      observe(this.personalInfoStore, "data", ({ newValue }) => {
        if (newValue) {
          this.validationStore.getOwnerNameOptions();
        }
      });

      observe(this.personalInfoStore, "error", ({ newValue: error }) => {
        if (error) {
          this.uiStore.setModalView(modalViewTypes.error);
        }
      });

      observe(
        this.validationStore,
        "loading",
        ({ newValue: isLoading, oldValue: wasLoading }) => {
          const finishedLoading = wasLoading && !isLoading;

          if (isLoading) {
            this.uiStore.setModalView(modalViewTypes.loading);
          }

          if (finishedLoading) {
            this.uiStore.setModalView(modalViewTypes.validation);
          }
        }
      );

      observe(
        this.validationStore,
        "hasCompletedValidation",
        ({ newValue: hasCompletedValidation }) => {
          if (hasCompletedValidation) {
            this.uiStore.setContentView(contentViewTypes.valuationLoading);
            this.valuationStore.fetchValuationData();
          }
        },
        true
      );

      observe(this.validationStore, "error", ({ newValue: error }) => {
        if (error) {
          this.uiStore.setModalView(modalViewTypes.error);
        }
      });

      observe(
        this.valuationStore,
        "loading",
        ({ newValue: isLoading, oldValue: wasLoading }) => {
          const finishedLoading = wasLoading && !isLoading;

          if (isLoading) {
            this.uiStore.setContentView(contentViewTypes.valuationLoading);
            this.uiStore.setModalView(modalViewTypes.loading);
          }

          if (finishedLoading) {
            this.uiStore.closeModal();

            if (this.valuationStore.error) {
              this.uiStore.setContentView(contentViewTypes.valuationError);
            } else {
              this.uiStore.setContentView(contentViewTypes.valuation);
            }
          }
        }
      );
    }
  };

export default withHomeClaimFlow;
